export default "__VITE_ASSET__CoFWA_Mc__"